import type { UniverseReference, User } from '@wecasa/common/src/types/commons';
import { isCleaningReference } from '@wecasa/common/src/utils/universes';

import { translate } from '@wecasa/i18n';

import { hasPaidMembership, hasRecurrentMembership } from './membership';

const t = translate('modals.membership_paywall');

const formatMembershipQuestions = (questions: string[]) =>
  questions.map((question) => ({
    content: t(`.faq.${question}.answer`),
    title: t(`.faq.${question}.question`),
  }));

type GetMembershipQuestionsParams = {
  universeReference: UniverseReference;
  user?: User;
  isSpotCleaning?: boolean;
};

export const getMembershipQuestions = ({ universeReference, user, isSpotCleaning }: GetMembershipQuestionsParams) => {
  if (isCleaningReference(universeReference)) {
    if (hasPaidMembership(user)) {
      return formatMembershipQuestions(['what_is_wecasa_club', 'what_if_cancelling_recurrence']);
    }

    if (hasRecurrentMembership(user)) {
      return formatMembershipQuestions([
        'what_is_wecasa_club',
        'when_active_subscription_recurring',
        'what_if_cancelling_recurrence',
      ]);
    }

    if (isSpotCleaning) {
      return formatMembershipQuestions([
        'what_is_wecasa_club',
        'when_active_subscription',
        'when_monthly_payment',
        'how_cancel_wecasa_club',
      ]);
    }

    if (!isSpotCleaning) {
      return formatMembershipQuestions([
        'what_is_wecasa_club',
        'when_active_subscription_recurring',
        'what_if_cancelling_recurrence',
      ]);
    }
  }

  // wellness
  return formatMembershipQuestions([
    'what_is_wecasa_club',
    'when_active_subscription',
    'when_monthly_payment',
    'how_cancel_wecasa_club',
  ]);
};
